module.exports = "img/prac-info-slide-9.1ae580.jpeg";